import { loadableWithFallback } from '@vision/ui/utils';
import type { TableDispatchProps } from './TableDispatch';

export const TableDispatch = loadableWithFallback<TableDispatchProps>(() => import('./TableDispatch'));
